import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { AVATAR_SIZES } from '@usepepper/ui/atoms/avatar';
import { createStyles } from '@/contexts/theme-context';
import { View } from 'react-native';

export const RestaurantSelectorSkeleton = () => {
  const [styles] = useStyles();

  return (
    <View accessibilityState={{ busy: true }} style={styles.container}>
      <AnimatedSkeletonLoader
        borderRadius={AVATAR_SIZES.small / 2}
        height={AVATAR_SIZES.small}
        width={AVATAR_SIZES.small}
      />
      <AnimatedSkeletonLoader height={14} width={76} />
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  container: {
    alignItems: 'center',
    borderColor: theme.sk.color.border.input.default,
    borderRadius: theme.sk.radii.radiusMedium,
    borderWidth: 1,
    flexDirection: 'row',
    gap: 8,
    paddingLeft: 12,
    paddingRight: 86,
    paddingVertical: 8,
  },
}));
